function makeUrl(fnName) {
  return `https://bd.baikalwater.ru/parse/functions/${fnName}`;
}

export default makeUrl;



// WEBPACK FOOTER //
// ./src/utils/makeParseUrl.js